export default __webpack_public_path__ + "static/media/play.2924c801.svg";